export default __webpack_public_path__ + "static/media/externalLinkImg.6235632c.svg";